<ng-container [formGroup]="group">
  <div
    class="custom-field radio-list"
    *ngIf="group.get(config.name) as field"
    [ngClass]="{ 'custom-field--invalid': showError(field) }"
    [class.has--label]="!!config.label"
  >
    <span class="label" (click)="collapsed = !collapsed">
      <span class="d-inline-block me-2">
        {{ config.label }}
        <span class="mat-form-field-required-marker" *ngIf="isRequired(field)">*</span>
      </span>

      <app-icon class="icon-xxxs collapsable-field-toggle" [class.is--active]="collapsed" anchor="icon-chevron-down-xxs"></app-icon>
    </span>

    <div class="mat-form-field-subLabel" *ngIf="config.subLabel" [innerHTML]="config.subLabel"></div>

    <ul
      class="custom-field__field collapsable-field"
      [class.is--collapsed]="collapsed"
      #collapsable
      [style.--collapsable-height]="collapsableHeight"
    >
      <li *ngFor="let option of config.selectOptions" class="me-2 my-2">
        <button type="button" class="radio" (click)="toggleOption(option.id)">
          <input [formControlName]="config.name" type="radio" [value]="option.id" hidden="hidden" />
          <span class="radio__bullet me-2" [class.is--selected]="group.get(config.name)?.value === option.id"></span>

          <span class="radio__label">{{ option.title }}</span>
        </button>
      </li>
    </ul>

    <div class="custom-field__error-wrapper">
      <div *ngIf="showError(field)">
        {{ error(field) }}
      </div>
    </div>
  </div>
</ng-container>
